import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { StyledFlex } from "../../../../styled/flex";
import { StyledFormHeader } from "../../../../styled/form";

const AddFormHeader = ({ formName, handleClose }) => {
  return (
    <StyledFormHeader.Container>
      <StyledFlex.Title>
        <Typography sx={StyledFormHeader.text}>
          INGRESANDO: {formName}
        </Typography>
      </StyledFlex.Title>
      <Tooltip title="Cerrar">
        <StyledFormHeader.CloseIcon onClick={handleClose} />
      </Tooltip>
    </StyledFormHeader.Container>
  );
};

export default AddFormHeader;
